
export default function Video() {
  return (
    <section id="how-it-works" className="py-20 bg-stone-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-800 mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
            This Is Not a Quick-Money Scheme
          </h2>
        </div>

        <div className="flex flex-col lg:flex-row gap-6 items-stretch justify-center mb-8">
          {/* YouTube Short - 9:16 portrait */}
          <div className="relative w-full lg:w-[280px] flex-shrink-0 mx-auto lg:mx-0" style={{ aspectRatio: '9/16', maxHeight: '500px' }}>
            <iframe
              className="absolute inset-0 w-full h-full rounded-xl shadow-xl"
              src="https://www.youtube.com/embed/Jnqw7rnrOIc?si=XgksMNNnWUMlswtu"
              title="Monthly Millionaire Project Short"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>

          {/* Original landscape video - 16:9 */}
          <div className="relative w-full lg:flex-1 mx-auto lg:mx-0" style={{ aspectRatio: '16/9', maxHeight: '500px' }}>
            <iframe
              className="absolute inset-0 w-full h-full rounded-xl shadow-xl"
              src="https://www.youtube.com/embed/xklawpsLY88?si=2nBJr0Kh-rL0f-SN"
              title="The Monthly Millionaire Project"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
        </div>

        <p className="text-base sm:text-lg text-gray-600 text-center max-w-3xl mx-auto leading-relaxed">
          This platform is for individuals who want structure, mentorship, and a health-based business that can grow beyond personal effort.
        </p>
      </div>
    </section>
  );
}
